import axios from "../api";
export const playerSwap = async ({ id, untradeable, excludeActiveSquad, excludeObjectivePlayers, excludeSbcPlayers, includeTransferList, prioritizeDuplicates, prioritizeSbcStorage, playerIds, excludedPlayers, minRating, maxRating, playersFrom, }) => {
    const response = await axios.post("/player-swap", {
        id,
        playersFrom,
        untradeable,
        // The API still requires the rarity flags; the apps no longer offer them.
        excludeGoldPlayers: false,
        excludeSilverPlayers: false,
        excludeBronzePlayers: false,
        excludeSpecialPlayers: false,
        excludeObjectivePlayers,
        excludeSbcPlayers,
        excludeActiveSquad,
        includeTransferList,
        prioritizeDuplicates,
        prioritizeSbcStorage,
        playerIds,
        excludedPlayers,
        minRating,
        maxRating,
    });
    if (response.data) {
        return response.data;
    }
    return [];
};
//# sourceMappingURL=playerSwap.js.map